import { UserRole } from 'types'
import { useCurrentWorkspaceId } from './useCurrentWorkspaceId'
import { useWorkspace } from './useWorkspace'
import { ALMANAC_CORE_WORKSPACE, ALMANAC_CORE_WORKSPACE_ID } from 'utils/constants'
import { useAuth } from './UseAuth'
import { useWorkspaces } from './useWorkspaces'

export function useUserRole() {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const workspaces = useWorkspaces()
  const workspace = useWorkspace(currentWorkspaceId)
  const auth = useAuth()

  // Real unauthed state
  if (auth == null) {
    return UserRole.UNAUTHED
  }

  // Legacy super admin mode
  if (auth.superAdminMode === currentWorkspaceId) {
    return UserRole.SUPER_ADMIN
  }

  // We cannot tell yet, the workspace being undefined is a loading state
  if (workspace == null) {
    // Your workspaces loaded (we start with [ALMANAC_CORE_WORKSPACE]), you are a visitor
    if (workspaces.length > 1) {
      return UserRole.UNAUTHED
    }
    // Odd case, you don't have ALMANAC_CORE_WORKSPACE, just some other workspace, you are a visitor
    if (workspaces.length === 1 && workspaces[0] !== ALMANAC_CORE_WORKSPACE) {
      return UserRole.UNAUTHED
    }
    return undefined
  }

  // TODO: Once the article/handbook's workspace is integrated back into redux this should become a dead path
  if (currentWorkspaceId === ALMANAC_CORE_WORKSPACE_ID) {
    return UserRole.UNAUTHED
  }

  // If your workspace is null and you are not logged in, you are unauthed
  return workspace.role
}
